module.exports = __webpack_public_path__ + "static/media/coins.e55f3575.jpg";